import { render, staticRenderFns } from "./SessionCountsDisplayDialog.vue?vue&type=template&id=0bfcb512&scoped=true"
import script from "./SessionCountsDisplayDialog.vue?vue&type=script&lang=js"
export * from "./SessionCountsDisplayDialog.vue?vue&type=script&lang=js"
import style0 from "./SessionCountsDisplayDialog.vue?vue&type=style&index=0&id=0bfcb512&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfcb512",
  null
  
)

export default component.exports